"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  switchTabWrapper: {
    width: "100%",
    height: "32px",
    backgroundColor: _variables.colors.swan,
    borderRadius: "10px",
    display: "flex",
    padding: "3px",
    direction: "rtl",
    position: "relative",
    top: "0",
    left: "0"
  },
  tab: {
    width: "50%",
    height: "100%",
    fontFamily: "IranSansX",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "10px",
    cursor: "pointer",
    zIndex: "1",
    userSelect: "none"
  },
  activeTab: function activeTab(data) {
    return {
      width: "calc(50% - 3px)",
      height: "calc(100% - 6px)",
      backgroundColor: _variables.colors.ghost,
      borderRadius: "8px",
      border: "1px solid ".concat(_variables.colors.hare),
      cursor: "default",
      position: "absolute",
      zIndex: "0",
      top: "50%",
      left: "50%",
      transform: "translate(".concat(data.props.tabList[0].id === data.activeTabId ? "0" : "-100%", ",-50%)"),
      transition: "0.2s"
    };
  }
}), {
  name: 'pds-switch-tab'
});
exports.useStyles = useStyles;